document.addEventListener('DOMContentLoaded', function() {
  var invDiv = document.getElementById('variant-inventory');
  var addBtn = document.getElementById('addToCart-product-template');

  if (!invDiv || !addBtn) return;

  function updateMessage() {
    if (addBtn.disabled) {
      invDiv.textContent = '🔴 Μη διαθέσιμο.';
    } else {
      invDiv.textContent = '🟢 Άμεση παραλαβή / Παράδοση 1 έως 3 ημέρες.';
    }
  }

  // αρχική ενημέρωση
  updateMessage();

  // αν το theme σου αλλάζει το disabled attribute,
  // το παρατηρούμε και ξανατρέχουμε το updateMessage
  var observer = new MutationObserver(function(muts) {
    muts.forEach(function(m) {
      if (m.attributeName === 'disabled') {
        updateMessage();
      }
    });
  });
  observer.observe(addBtn, { attributes: true });

  // προληπτικά, ακούς και σε αλλαγές variant selects/radios
  var selectors = document.querySelectorAll('select[name="id"], input[name="id"]');
  selectors.forEach(function(el) {
    el.addEventListener('change', function() {
      // μικρό timeout για να προλάβει να αλλάξει το theme το κουμπί
      setTimeout(updateMessage, 50);
    });
  });
});